import { useQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

function useSpecRecipePaginatedSearch(searchTerm, page, filters) {
  const queryReturnValues = useQuery(
    [
      "paginated-spec-recipe-search",
      { page, searchTerm, filters },
    ],
    inventoryClient.searchSpecRecipesPaginated,
    {
      enabled: !!searchTerm,
      refetchOnWindowFocus: false,
    }
  );

  return queryReturnValues;
}

export default useSpecRecipePaginatedSearch;
